/**
 * useDailyEnergy Hook
 *
 * Fetches half-hourly energy slots (consumption + tariff rates) for a
 * single day via the get_daily_energy_slots RPC.
 */

import { useState, useEffect, useCallback } from 'react'
import { supabase } from '@/supabase-client'

export function useDailyEnergy(date, refreshKey) {
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchSlots = useCallback(async () => {
    if (!date) return

    setIsLoading(true)
    setError(null)

    try {
      const { data: slots, error: rpcError } = await supabase.rpc(
        'get_daily_energy_slots',
        { p_date: date }
      )

      if (rpcError) throw rpcError

      setData(slots || [])
    } catch (err) {
      console.error('[useDailyEnergy] Failed:', err)
      setError(err.message)
      setData([])
    } finally {
      setIsLoading(false)
    }
  }, [date, refreshKey])

  useEffect(() => {
    fetchSlots()
  }, [fetchSlots])

  return { data, isLoading, error, refresh: fetchSlots }
}

export default useDailyEnergy
